import PortalIdParser from 'PortalIdParser';
export const API_BASE_URL = 'onboardingtours/v1';
export const TOUR_ID = 'tourId';
export const ONBOARDING_TOUR_ID = 'onboardingTourId';
export const getUserGuideUrl = () => `/user-guide/${PortalIdParser.get()}`;